export default function (value) {
  if (!value) {
    return '-'
  }

  return value
}



// WEBPACK FOOTER //
// ./src/components/Filters/NoEmpty.js